import Vue from "vue";
import Moment from "moment";

// 秒转为min
Vue.filter("formatSecondToMIN", function(value) {
  let time = Moment.duration(value, "seconds");
  let minutes = time.minutes();
  return Moment({ m: minutes }).format("m");
});
